import React from 'react';
import {
  Divider,
  Grid,
  Tooltip,
  Typography,
  styled,
} from '@nextiva/next-ui-components';
import { SvgCircleInfo } from 'components/SvgIcon';

const StyledHeaderTitleTypography = styled(Typography)`
  font-weight: 800;
  padding: 0 0 6px 50px;
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;
const StyledTeamSMSTitleTypography = styled(Typography)`
  font-weight: 800;
  padding-bottom: 6px;
  position: relative;
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;
const StyledSvgCircleInfo = styled(SvgCircleInfo)`
  position: absolute;
  top: -2px;
`;

export const TableHeader = ({ smsEnabled }) => {
  return (
    <>
      <Grid container direction="row">
        <Grid item xs={6}>
          <StyledHeaderTitleTypography variant="body1">
            Name
          </StyledHeaderTitleTypography>
        </Grid>
        <Grid item xs={6}>
          {smsEnabled && (
            <Tooltip
              title="Only users with blue icons below have a Message Pro license assigned and can receive/send text messages from this team. To add a license to a user, click the box next to their name and then click Save."
              placement="top"
            >
              <StyledTeamSMSTitleTypography variant="body1">
                Message Pro <StyledSvgCircleInfo />
              </StyledTeamSMSTitleTypography>
            </Tooltip>
          )}
        </Grid>
      </Grid>
      <Divider orientation="horizontal" variant="fullWidth" />
    </>
  );
};
